import isEmpty from "lodash/isEmpty";
import { fetchSettings } from "src/contexts/customFields";
import useAuth from "src/hooks/useAuth";
import { useQuery } from "@apollo/client/react";
import { FETCH_PROJECT_QUERY } from "src/constants/graphql/queries";

export default function useCaptureFields(currentProject, projectId) {
  const { user } = useAuth();
  const { company } = user;
  const { data: { project: assetProject = {} } = {}, loading } = useQuery(FETCH_PROJECT_QUERY, {
    variables: { id: projectId },
    skip: currentProject.id,
  });
  const project = currentProject.id ? currentProject : assetProject;
  const displayProjectFields = fetchSettings(project);
  const displayUserFields = isEmpty(user.captureTableSettings)
    ? displayProjectFields || company.fieldSettings
    : user.captureTableSettings;
  const enableProjectSpecificFields = user.company.settings.project_specific_fields;

  if (enableProjectSpecificFields) {
    return [displayProjectFields || company.fieldSettings, loading];
  }

  return [displayUserFields, loading];
}
